/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import propTypes from 'prop-types';
import {
  ScrollingCarousel,
  ScrollingCarouselStep,
  ImageGalleryModal,
} from '@landtrustinc/design-system';
import { formatTimeAgo } from '../../../util/dates';
import NamedLink from '../../../components/NamedLink/NamedLink';
import { createSlug } from '../../../util/urlHelpers';
import { getPackage } from '../../../util/listing';
import Avatar from '../../../components/Avatar/Avatar';
import OptionMenu from '../../../components/OptionMenu/OptionMenu';
import css from './ListingUpdate.module.css';

const SectionPhotosUpdate = props => {
  const {
    listing,
    activity,
    currentPackage,
    isListing,
    renderBellIcon,
    fetchTotalLikesData,
    authUser,
  } = props;

  const activityPhotos = activity.photos || [];
  const hasImages = activityPhotos.length > 0;
  const { title } = listing.attributes;
  const listingUrl = `/l/${createSlug(title)}/${listing.id.uuid}`;
  const updateId = activity?.id;
  const carouselId = `photos-update-carousel-${updateId}`;

  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const galleryImages = activityPhotos.map((image, index) => ({
    src: image.path,
    alt: `Activity update ${index + 1} from ${title}`,
  }));

  const handleImageClick = index => {
    setSelectedIndex(index);
    setIsGalleryOpen(true);
  };

  const { packageId } = activity;
  const activityPackage = getPackage(listing, packageId);
  const activityPackageTitle = activityPackage?.title;

  const packageName = currentPackage ? currentPackage.title : '';
  const slug = createSlug(packageName);
  const id = listing.id.uuid;

  const richTitle = activityPackageTitle && (
    <NamedLink className={css.titleLink} name="PackagePage" params={{ id, slug, packageId }}>
      {activityPackageTitle} package
    </NamedLink>
  );

  let messageID;

  if (!isListing && currentPackage?.id === packageId) {
    messageID = 'ListingPage.activityFeedNewPhotoThisPackage';
  } else if (activityPackageTitle) {
    messageID = 'ListingPage.activityFeedNewPhoto';
  } else {
    messageID = 'ListingPage.activityFeedDefaultMessage';
  }

  if (!isListing && currentPackage?.id !== packageId) {
    return null;
  }

  return (
    <>
      {hasImages && (
        <>
          <div key={activity.createdAt} className={css.content}>
            <div className={css.info}>
              <div className={css.flexContainer}>
                <div className={css.avatarContainer}>
                  <NamedLink name="ListingPage" params={{ id: listing.id.uuid, slug }}>
                    <>
                      <Avatar
                        user={listing.author}
                        disableProfileLink
                        className={css.customAvatarSize}
                        listing={listing}
                        useListingImage
                      />
                      {renderBellIcon}
                    </>
                  </NamedLink>
                </div>
                <div className={css.propertyNameContainer}>
                  <div className={css.propertyName}>
                    <NamedLink name="ListingPage" params={{ id: listing.id.uuid, slug }}>
                      <FormattedMessage
                        id="ListingPage.activityFeedPropertyName"
                        values={{
                          propertyName: listing.attributes.title,
                        }}
                      />
                    </NamedLink>
                  </div>
                  <div className={css.dateWrapper}>
                    <span className={css.dateContainer}>
                      <p className={css.landownerContainer}>
                        <FormattedMessage
                          id="ListingPage.activityFeedPhotoUpdate"
                          values={{
                            landownerName: listing.author.attributes.profile.displayName,
                          }}
                        />
                        {' • '}
                        {formatTimeAgo(activity?.createdAt)}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div className={css.postWrapper}>
                <div className={css.descriptionStyles}>
                  <FormattedMessage id={messageID} values={{ richTitle }} />
                </div>

                {hasImages && (
                  <>
                    <ScrollingCarousel id={carouselId} showDots={activityPhotos.length > 1}>
                      {activityPhotos.map((image, index) => (
                        <ScrollingCarouselStep
                          key={image.path || index}
                          parentId={carouselId}
                          onClick={() => handleImageClick(index)}
                        >
                          <div className={css.imageWrapper}>
                            <img
                              src={image.path}
                              className={css.imageStyles}
                              alt={`Activity update ${index + 1} from ${title}`}
                            />
                          </div>
                        </ScrollingCarouselStep>
                      ))}
                    </ScrollingCarousel>

                    {galleryImages.length > 0 && (
                      <ImageGalleryModal
                        id={`${carouselId}-gallery`}
                        isOpen={isGalleryOpen}
                        onClose={() => setIsGalleryOpen(false)}
                        images={galleryImages}
                        initialIndex={selectedIndex}
                      />
                    )}
                  </>
                )}
              </div>
              <OptionMenu
                listingUrl={listingUrl}
                updateId={updateId}
                fetchTotalLikesData={fetchTotalLikesData}
                authUser={authUser}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

SectionPhotosUpdate.defaultProps = {};

SectionPhotosUpdate.propTypes = {
  listing: propTypes.object.isRequired,
};

export default SectionPhotosUpdate;
